import Tooltip from '@mui/material/Tooltip';
import cx from 'classnames';
import React from 'react';
import Styles from './IconButton.scss';
import { IIconButtonProps } from './Interfaces';

const IconButton = (props: IIconButtonProps) => {
    const {
        tooltip,
        id,
        icon,
        onClick,
        isSelected,
        style,
        className,
        disabled,
    } = props;

    if (tooltip) {
        let btn = (
            <button
                id={id}
                style={style}
                disabled={disabled}
                className={cx(
                    Styles.iconBtn,
                    isSelected ? Styles.iconBtnSelected : null,
                    className
                )}
                onClick={onClick}
            >
                {icon}
            </button>
        );

        if (disabled) {
            btn = <span>{btn}</span>;
        }

        return <Tooltip title={tooltip}>{btn}</Tooltip>;
    }

    return (
        <button
            id={id}
            style={style}
            disabled={disabled}
            className={cx(
                Styles.iconBtn,
                className,
                isSelected ? Styles.iconBtnSelected : null
            )}
            onClick={onClick}
        >
            {icon}
        </button>
    );
};

export default IconButton;
